import React, { createContext, useContext } from 'react';
import { DefaultConfigurationType } from '~graphql/__generated__/types';

export type DefaultConfigurations = {
  id: string;
  type: DefaultConfigurationType;
  defaultConfigurations: Array<{
    platform: string;
    configurationId: string;
  }>;
};

type DefaultConfigurationContextType = {
  defaultConfigurations: DefaultConfigurations[] | null;
  multiClaimDefaultConfigurations: DefaultConfigurations[] | null;
};

export const DefaultConfigurationContext = createContext<DefaultConfigurationContextType>({
  defaultConfigurations: [],
  multiClaimDefaultConfigurations: [],
});

export const DefaultConfigurationProvider: React.FC<{
  defaultConfigurations: DefaultConfigurations[] | null;
  multiClaimDefaultConfigurations: DefaultConfigurations[] | null;
  children: React.ReactNode;
}> = ({ defaultConfigurations, multiClaimDefaultConfigurations, children }) => {
  return (
    <DefaultConfigurationContext.Provider
      value={{ defaultConfigurations, multiClaimDefaultConfigurations }}
    >
      {children}
    </DefaultConfigurationContext.Provider>
  );
};
export const useDefaultConfiguration = () => {
  const ctx = useContext(DefaultConfigurationContext);
  if (!ctx) {
    throw new Error('useDefaultConfiguration must be used within a DefaultConfigurationProvider');
  }
  return ctx;
};
